<div class="bmc-job-settings">
  <div class="bmc-job-settings__top-section">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.NAME' | translate}}</h5>
      <ng-container *ngIf="isDevelopment; else editName">
        <h5>{{currentJob.name}}</h5>
      </ng-container>
      <ng-template #editName>
        <input 
          type="text" 
          [(ngModel)]="currentJob.name" 
          class="bmc-job-settings__input" 
          [disabled]="currentJob.disableEditJob"
          [ngClass]="{ 'valid': isValidCurrentJobName, 'invalid': isValidCurrentJobName === false }"
          (input)="validateInputJobName($event)"
          maxlength="24"
        />
      </ng-template>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.CREATION_DATE' | translate}}</h5>
      <h5>{{currentJob.creationDate | showDateFormat: 1}}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__top-section bmc-job-settings__top-section-second">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_NUMBER' | translate}}</h5>
      <h5>{{currentJob.radNumber}}</h5>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_ID' | translate}}</h5>
      <h5>{{currentJob.idCase}}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__middle-section">
    <div class="bmc-job-settings__middle-section__left">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.DESCRIPTION' | translate}}</h5>
      <ng-container *ngIf="isDevelopment; else editDesc">
        <h5 class="bmc-job-settings__middle-section__left__text">{{currentJob.description}}</h5>
      </ng-container>
      <ng-template #editDesc>
        <input 
          type="text" 
          [(ngModel)]="currentJob.description" 
          class="bmc-job-settings__input" 
          [disabled]="currentJob.disableEditJob" 
        />
      </ng-template>
    </div>
  </div>
  <div class="bmc-job-settings__enable mt">
    <bzg-switch [(ngModel)]='currentJob.enabled' [disabled]="currentJob.disableEditJob === true"></bzg-switch>
    <h5 class="bmc-job-settings__enable__text">{{ 'GLOBAL.ENABLED' | translate}}</h5>
  </div>
  <div class="bmc-job-settings__enable mt" *ngIf="shouldShowSwitch()">
    <bzg-switch [(ngModel)]="jobStates[currentJob.guid].rescheduleJob" (ngModelChange)="checkAndSetDate()"></bzg-switch>
    <h5 class="bmc-job-settings__enable__text">{{ 'JOBS.RESCHEDULE_JOB' | translate}}</h5>
  </div>
  <div *ngIf="shouldShowDateSection()" class="bmc-job-settings__date-section bz-space--stack-m">
    <h5 class="bz-font-weight--semibold bz-space--stack-s">{{'JOBS.NEXT_RUN_TIME' | translate}}</h5>
    <div class="bmc-job-settings__date-section__run-time">
      <div class="bmc-job-settings__date-section__top bz-space--stack-s">
        <div class="bmc-job-settings__date__input bz-form-item--required bz-form-item bz-space--inline-s" [ngClass]="{'bz-form-item--error' :
          (dpToControl.invalid) && (dpToControl.dirty || dpToControl.touched)}">
          <label class="bz-form-label">{{'GLOBAL.DATE' | translate}}
            <span class="bz-required__icon">*</span>
          </label>
          <div class="bz-input-icon">
            <input class="bz-input bz-input-icon__input bz-space--inline-s" autocomplete="off"
              placeholder="{{'GLOBAL.SELECT_A_DATE' | translate}}" mask="00/00/0000" id="date-to" #dpTo="bsDatepicker"
              #dpToControl="ngModel" [(ngModel)]="nextRuntimeDate" (ngModelChange)="onDateChange($event)" name="date-to"
              [bsConfig]="{ showWeekNumbers: false }" required [disabled]="currentJob.disableEditJob" bsDatepicker>
            <svg class="bz-icn bz-space--inline-s" height="32px" width="32px"
              (click)="currentJob.disableEditJob || dpTo.show()">
              <use xlink:href="#icon-calendar"></use>
            </svg>
          </div>
          <div class="bz-form-message">
            <span class="bz-form-message__error" *ngIf="dpToControl.invalid && (dpToControl.dirty || dpToControl.touched) && dpToControl.errors.required">
              <svg class="bz-icn bz-space--inline-s" width="16px" height="16px">
                <use xlink:href="#icn-input-error" />
              </svg>
              <label class="bz-form-message__text">
                {{'GLOBAL.REQUIRED_FIELD' | translate}}
              </label>
            </span>
          </div>
        </div>
      </div>
      <div class="bmc-job-settings__date-section__bottom">
        <bzg-time-picker class="" name="finished-date" *ngIf="nextRuntimeDateTime.period"
          [(ngModel)]="nextRuntimeDateTime"
          (ngModelChange)="onTimeChange($event)"
          [required]="true" 
          [disabled]="currentJob.disableEditJob">
          {{'JOBS.TIME' | translate}}
        </bzg-time-picker>
        <div class="bmc-job-settings__date-section__bottom__button">
          <bzg-button-primary [disabled]="currentJob.disableEditJob" (click)="setJobNow()">{{'JOBS.SET_JOB_NOW' |
            translate}}</bzg-button-primary>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="" *ngIf="showReset">
    <h5 class="bz-font-weight--semibold">{{'JOBS.RESET_DEVELOP_TITLE' | translate}}</h5>
    <div class="bz-form-message__text">{{'JOBS.RESET_DEVELOP' | translate}} <a class="bmc-job-settings__reset--link"
        (click)="resetJob()">{{ 'GLOBAL.RESET' | translate}}</a>
    </div>
  </div>

  <bzg-message  *ngIf="showValidationMessage" [showCloseBtn]="false" [status]="'warning'">
    <span class="bz-space--inline-s "> {{validationMessage | translate}} </span>
  </bzg-message>
</div>



<job-form-buttons
  [validationMessage]="validationMessage"
  [showValidationMessage]="false"
  [applyDisabled]="applyDisabled"
  [currentJobDisableEdit]="currentJob.disableEditJob"
  (apply)="applyChanges()"
  (cancel)="cancelChanges()">
</job-form-buttons>